import { webKnots } from '../../../../common/back/lace/webKnots'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const type27Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  // 外側
  ctx.beginPath()
  ctx.moveTo(530, 74) // 左上
  ctx.quadraticCurveTo(481, 164, 467, 243) // 左下1
  ctx.quadraticCurveTo(466, 254, 473, 278) // 左下2
  ctx.quadraticCurveTo(506, 346, 575, 366) // 右下1
  ctx.quadraticCurveTo(638, 345, 697, 290) // 右上
  ctx.quadraticCurveTo(660, 140, 530, 74) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(532, 80) // 左上
  ctx.quadraticCurveTo(483, 166, 470, 250) // 左下
  ctx.quadraticCurveTo(488, 333, 574, 362) // 右下
  ctx.quadraticCurveTo(639, 337, 692, 288) // 右上
  ctx.quadraticCurveTo(650, 140, 532, 80) // 左上
  // 内側
  ctx.moveTo(535, 82) // 左上
  ctx.quadraticCurveTo(487, 166, 473, 250) // 左下
  ctx.quadraticCurveTo(490, 328, 573, 359) // 右下
  ctx.quadraticCurveTo(637, 332, 688, 288) // 右上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()

  // 左側面
  leftLace(ctx, laceColor, 5, 0, 0) //
  leftLace(ctx, laceColor, -32, 95, -4) //
  leftLace(ctx, laceColor, -114, 240, -15) //
  // 右側面
  rightLace(ctx, laceColor, 5, 5, 0) //
  rightLace(ctx, laceColor, -8, -24, 5) //
  rightLace(ctx, laceColor, -25, -50, 10) //

  underLeftLace(ctx, laceColor) // 下側面
  underRightLace(ctx, laceColor) // 下側面
  // stitchここまで
  webKnots(ctx, laceColor, -100, 95, 1) // ウェブ先端寄りのウェブ結び目
}

const leftLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number, numerator: number, scaleSize?: number) => {
  ctx.beginPath()
  if (numerator !== undefined && numerator !== 0) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
    if (scaleSize !== undefined) {
      ctx.scale(scaleSize, scaleSize)
    }
  }

  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(529 + x, 93 + y) // 左上
  ctx.quadraticCurveTo(516 + x, 107 + y, 511 + x, 134 + y) // 左下
  ctx.quadraticCurveTo(509 + x, 137 + y, 521 + x, 137 + y) // 右下
  ctx.quadraticCurveTo(529 + x, 113 + y, 536 + x, 98 + y) // 右上
  ctx.quadraticCurveTo(532 + x, 92 + y, 529 + x, 93 + y) // 左上
  ctx.fill()
  ctx.moveTo(535 + x, 97 + y)
  ctx.quadraticCurveTo(525 + x, 107 + y, 519 + x, 137 + y)
  ctx.stroke()
  if (numerator !== undefined) {
    ctx.restore()
  }
  ctx.closePath()
}

const rightLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number, numerator: number, scaleSize?: number) => {
  ctx.beginPath()
  if (numerator !== undefined && numerator !== 0) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
    if (scaleSize !== undefined) {
      ctx.scale(scaleSize, scaleSize)
    }
  }

  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(675 + x, 267 + y) // 左上
  ctx.quadraticCurveTo(651 + x, 287 + y, 651 + x, 287 + y) // 左下
  ctx.quadraticCurveTo(648 + x, 292 + y, 653 + x, 299 + y) // 右下
  ctx.quadraticCurveTo(677 + x, 280 + y, 677 + x, 278 + y) // 右上
  ctx.quadraticCurveTo(680 + x, 272 + y, 675 + x, 267 + y) // 左上
  ctx.fill()
  ctx.moveTo(675 + x, 270 + y)
  ctx.quadraticCurveTo(661 + x, 286 + y, 651 + x, 290 + y)
  ctx.stroke()
  if (numerator !== undefined) {
    ctx.restore()
  }
  ctx.closePath()
}

const underLeftLace = (ctx: CanvasRenderingContext2D, laceColor: string) => {
  ctx.beginPath()
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(488, 280) // 左下
  ctx.quadraticCurveTo(500, 305, 507, 305) // 右下
  ctx.quadraticCurveTo(513, 301, 513, 298) // 右上
  ctx.quadraticCurveTo(505, 291, 495, 275) // 左上
  ctx.quadraticCurveTo(488, 275, 488, 280) // 左下
  ctx.fill()
  ctx.moveTo(494, 277)
  ctx.quadraticCurveTo(500, 292, 513, 301)
  ctx.stroke()
  ctx.closePath()
}

const underRightLace = (ctx: CanvasRenderingContext2D, laceColor: string) => {
  ctx.beginPath()
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(525, 321) // 左下
  ctx.quadraticCurveTo(533, 335, 554, 341) // 右下
  ctx.quadraticCurveTo(562, 338, 560, 335) // 右上
  ctx.quadraticCurveTo(542, 326, 532, 316) // 左上
  ctx.quadraticCurveTo(525, 315, 525, 321) // 左下
  ctx.fill()
  ctx.moveTo(532, 318)
  ctx.quadraticCurveTo(542, 330, 560, 337)
  ctx.stroke()
  ctx.closePath()
}
